module.exports = __webpack_public_path__ + "img/hemline sweep.ffec602d.png";